import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ApiService } from '../pages/services/api.service';

@Injectable()
export class WhatsAppGuard implements CanActivate {
  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    if(this.apiService.isWaConfigAdded()) return true;

    this.router.navigate(['/dashboard']);
    return false;
  }
}
